import Building from "@models/building/Building";
import Roomtypeat from '@models/helpers/RoomtypeAt'
import Unitairvolume from "@models/airvolumes/Unitairvolume";
import Roomairvolume from "@models/airvolumes/Roomairvolume";
import store from "@store";
import Unit from "../../models/building/Unit";
import Systemselection from "@models/airvolumes/Systemselection";
import Installation from "@models/airvolumes/Installation";
import Valve from "@models/airvolumes/Valve";
import RoomtypesHasOperationmodesHasAirvolume from "@models/helpers/RoomtypesHasOperationmodesHasAirvolume";
import RoomltmsHasOperationmode from "@models/helpers/RoomltmsHasOperationmodeAt";

export default {
  calculate(unitId = null) {
    this.building = Building.query().first();
    this.unit = Unit.query()
      .where("id", unitId)
      .with([
        "airvolume",
        "installation",
        "systemselection",
        "rooms.airvolume",
        "rooms.valve",
      ])
      .first();

    if (this.unit.rooms.length <= 0) return;

    if (this.unit.airvolume == null) {
      this.unit.airvolume = new Unitairvolume({unitId: this.unit.id});
    }
    if (this.unit.systemselection == null) {
      this.unit.systemselection = new Systemselection({
        unitId: this.unit.id,
        deviceLevel: this.unit.level,
      });
    }
    if (this.unit.installation == null) {
      this.unit.installation = new Installation({
        unitId: this.unit.id,
        storey: this.unit.storey,
      });
    }
    this.unit.rooms.forEach((room) => {
      if (room.airvolume == null) {
        room.airvolume = new Roomairvolume({
          roomId: room.id,
          doorLeaf: room.getRoomtypeDoorLeaf(),
        });
      }
      if (room.airvolume.doorLeaf == 0 || room.airvolume.doorLeaf == null) {
        room.airvolume.doorLeaf = 86;
      }
      if (room.valve == null) {
        room.valve = new Valve({roomId: room.id});
      }
      if (room.airType == 3) room.airvolume.resetOverflowRoom();
    });

    this.getConstants();
    this.basicCalculations();
    // this.fZuCalculation();

    this.calculate18017TotalExhaustAir();
    this.calculateEquation8a();
    this.calculateEquation15();
    this.calculateEquation9();

    this.setDefaultOperationmode();
    this.calculateTotalOperationmodeAir();

    // if total duration air < unit airvolume fl then calculate equation 39 else calculate equation 38
    // info: keep equation 39 in code for future use
    //    if (this.unit.airvolume.totalDurationAir < this.unit.airvolume.fl) {
    //      this.calculateEquation39()
    //    } else {
    this.calculateEquation38();
    //    }
    this.calculate18017SupplyAir();
    //this.calculateExhaustAir()

    this.calculateTotalAirvolumes();
    this.calculateAirvolumeVariations();
    this.calculateUld();
    this.calculateValves();

    Unit.insertOrUpdate({data: [this.unit]});
    return;
  },

  getConstants() {
    this.fLstnl = store.getters["constants/getFlstnl"];
    this.fLstil = store.getters["constants/getFlstil"];
    this.fLstrl = store.getters["constants/getFlstrl"];
    this.fLstfl = store.getters["constants/getTable6Constant"]({
      buildingHeatProtection: this.building.heatProtection,
      unitOccupancy: this.unit.occupancy,
    });
    this.eZ = store.getters["constants/getTable9Constant"]({
      unitLtm: this.unit.ventilationMeasure,
      unitFireplace: this.unit.fireplace,
    });
    this.eZFree = store.getters["constants/getTable5Constant"]({
      buildingLocation: this.building.location,
      unitMultiStorey: this.unit.multiStorey,
    });
    this.n50 = store.getters["constants/getTable10Constant"]({
      buildingAirtightness: this.building.airtightness,
      buildingAirExchange: this.building.airExchange,
    });
  },

  basicCalculations() {
    this.unit.airvolume.space = 0;
    this.unit.airvolume.height = 0;
    this.unit.airvolume.volume = 0;

    this.unit.airvolume.aldSpace = 0;
    this.unit.airvolume.aldVolume = 0;

    this.unit.rooms.forEach(
      function (room) {
        this.unit.airvolume.space += room.space;
        if (room.ventilationMeasure != 1)
          this.unit.airvolume.aldSpace += room.space;
        this.unit.airvolume.height += room.height;
      }.bind(this)
    );

    this.unit.airvolume.height =
      this.unit.airvolume.height / this.unit.rooms.length;
    this.unit.airvolume.volume = +parseFloat(
      (this.unit.airvolume.space * this.unit.airvolume.height).toFixed(2)
    );
    this.unit.airvolume.aldVolume = +parseFloat(
      (this.unit.airvolume.aldSpace * this.unit.airvolume.height).toFixed(2)
    );
  },

  fZuCalculation() {
    this.unit.rooms.forEach(
      function (room) {
        if (!(room.airType == 2 || room.ventilationMeasure == 2)) return;
        if (room.airvolume.fZu == null || room.airvolume.fZu <= 0) {
          room.airvolume.fZu = +parseFloat(room.getRoomtype().f_zu).toFixed(1);
        }
        this.unit.airvolume.totalFrZu += +parseFloat(
          room.getRoomtype().f_zu
        ).toFixed(1);
      }.bind(this)
    );
  },

  totalExhaustAirCalculation() {
    this.unit.airvolume.exhaustAir = 0;
    this.unit.rooms.forEach((room) => {
      if (room.airType != 1 || room.ventilationMeasure == 7) return;
      this.unit.airvolume.exhaustAir += room.getRoomtypeAirvolume();
    });
  },

  calculateEquation9() {
    this.unit.airvolume.infiltrationAir =
      this.eZ * this.unit.airvolume.volume * this.n50;
  },

  calculate18017TotalExhaustAir() {


    this.unit.airvolume.exhaustAir = 0;
    this.unit.airvolume.ald = 0;
    this.unit.rooms.forEach((room) => {
      const roomtypeat = Roomtypeat.query().where('id', room.type).first();

      if (room.ventilationMeasure != 1) return;
      if (roomtypeat.air_type != 1) return;


      const airvolume = roomtypeat.airvolume_exhaust_operating
      this.unit.airvolume.exhaustAir += roomtypeat.airvolume_exhaust_operating
      if (this.building.heatProtection === 1) {
        this.unit.airvolume.ald += roomtypeat.airvolume_exhaust_operating;
      } else {
        this.unit.airvolume.ald += roomtypeat.airvolume_exhaust_basic;
      }

    });
  },

  calculateEquation8a() {
    this.unit.airvolume.nl =
      this.fLstfl *
      (-0.002 * Math.pow(this.unit.airvolume.aldSpace, 2) +
        1.15 * this.unit.airvolume.aldSpace +
        11);
  },

  calculateEquation15() {
    this.unit.airvolume.fl = Math.max(
      this.unit.airvolume.nl,
      0.5 * this.unit.airvolume.ald
    );
  },

  calculateEquation39() {
    // set unit.airvolume nl to max of:
    // => (this.unit.airvolume.totalNeedAir - this.unit.airvolume.infiltrationAir) * 0,5
    // => 2 * ( this.unit.airvolume.nl - this.unit.airvolume.infiltrationAirFree )
    const infiltration = this.unit.airvolume.infiltrationAir;
    this.unit.airvolume.infiltrationAir =
      this.eZFree * this.unit.airvolume.volume * this.n50;

    this.unit.airvolume.nl = Math.max(
      (this.unit.airvolume.totalNeedAir - infiltration) * 0.5,
      2 * (this.unit.airvolume.nl - this.unit.airvolume.infiltrationAir)
    );
  },

  calculateEquation38() {
    this.unit.airvolume.nl =
      this.unit.airvolume.totalNeedAir - this.unit.airvolume.infiltrationAir;
  },

  calculate18017SupplyAir() {
    var airvolume = 0;
    var ald = 0;
    var inf = 0;
    var nl = 0;
    this.unit.rooms.some(
      function (room) {
        if (room.ventilationMeasure != 2) return;
        const roomtypeat = Roomtypeat.query().where('id', room.type).first()

        airvolume = roomtypeat.airvolume_exhaust_operating;

        room.airvolume.ald = Math.round(
          (this.unit.airvolume.nl / Math.round(this.unit.airvolume.ald)) *
          airvolume
        );

        room.airvolume.infiltrationAir = Math.round(
          (this.unit.airvolume.infiltrationAir / this.unit.airvolume.ald) *
          airvolume
        );
        room.airvolume.airvolume = Math.round(
          room.airvolume.ald + room.airvolume.infiltrationAir
        );

        ald += room.airvolume.ald;
        inf += room.airvolume.infiltrationAir;
        nl += room.airvolume.airvolume;
      }.bind(this)
    );

    this.unit.airvolume.ald = Math.round(ald);
    this.unit.airvolume.il = Math.round(inf);
    this.unit.airvolume.infiltrationAir = Math.round(inf);
    this.unit.airvolume.nl = Math.round(nl);
  },

  calculateExhaustAir() {
    this.unit.rooms.forEach(
      function (room) {
        if (room.ventilationMeasure == 7) {
          room.airvolume.airvolume = 0;
          return;
        }
        if (room.ventilationMeasure != 1 && room.ventilationMeasure != 6)
          return;
        room.airvolume.airvolume =
          (room.getRoomtypeAirvolume() * this.unit.airvolume.nl) /
          this.unit.airvolume.exhaustAir;
      }.bind(this)
    );
  },

  setDefaultOperationmode() {
    let noRpnRooms = Math.ceil(Math.ceil(this.unit.airvolume.fl) / 25);

    const exhaustRooms = [];
    // get array with all exhaust rooms (ventilationMeasure = 1)
    this.unit.rooms.forEach((room) => {
      if (room.ventilationMeasure != 1) return;

      if (
        room.airvolume.operationmode == 3 ||
        room.airvolume.operationmode == 4
      ) {
        noRpnRooms--;
        return;
      }

      if (
        room.airvolume.operationmode != null ||
        room.airvolume.operationmode > 0
      ) {
        return;
      }
      exhaustRooms.push(room);
    });

    // sort exhaust rooms by type typ 1, 2 and 5 have highest priority otherwise sort by id
    exhaustRooms.sort((a, b) => {
      if (a.type == 1 && b.type != 1) return -1;
      if (a.type == 2 && b.type != 1 && b.type != 2) return -1;
      if (a.type == 5 && b.type != 1 && b.type != 2 && b.type != 5) return -1;
      return a.type - b.type;
    });

    // store room ids of noRpnRooms exhaust rooms in an array
    const rpnRoomIds = exhaustRooms.slice(0, noRpnRooms).map((room) => room.id);
    this.unit.rooms.forEach((room) => {
      if (
        room.airvolume.operationmode == null ||
        room.airvolume.operationmode <= 0 ||
        !RoomltmsHasOperationmode.query()
          .where("roomltms_id", room.ventilationMeasure)
          .where("operationmodes_id", room.airvolume.operationmode)
          .exists()
      ) {
        var operationmode = RoomltmsHasOperationmode.query()
          .where("roomltms_id", room.ventilationMeasure)
          .where("default", 1)
          .first();
        if (rpnRoomIds.indexOf(room.id) >= 0) {
          operationmode = RoomltmsHasOperationmode.query()
            .where("roomltms_id", room.ventilationMeasure)
            .where("operationmodes_id", 3)
            .first();
        }
        room.airvolume.operationmode = operationmode.operationmodes_id;
      }

      if (
        room.airvolume.operationmodeAirvolume == null ||
        room.airvolume.operationmodeAirvolume <= 0 ||
        !RoomtypesHasOperationmodesHasAirvolume.query()
          .where("id", room.airvolume.operationmodeAirvolume)
          .where("operationmodes_id", room.airvolume.operationmode)
          .exists()
      ) {
        var operationmodeAirvolume =
          RoomtypesHasOperationmodesHasAirvolume.query()
            .where("operationmodes_id", room.airvolume.operationmode)
            .where("roomtypes_id", room.type)
            .where("window", +room.window)
            .where("default", true)
            .first();
        if (
          operationmodeAirvolume != undefined ||
          operationmodeAirvolume != null
        ) {
          room.airvolume.operationmodeAirvolume = operationmodeAirvolume.id;
        }
      }
    });
  },

  calculateTotalOperationmodeAir() {
    this.unit.airvolume.totalNeedAir = 0;
    this.unit.airvolume.totalDurationAir = 0;
    this.unit.rooms.forEach(
      function (room, index) {
        if (
          room.airvolume.operationmodeAirvolume == null ||
          room.airvolume.operationmodeAirvolume <= 0 ||
          !(room.ventilationMeasure == 1 || room.ventilationMeasure == 6)
        )
          return;
        var operationmodeAirvolume =
          RoomtypesHasOperationmodesHasAirvolume.find(
            room.airvolume.operationmodeAirvolume
          );
        const roomtypeat = Roomtypeat.query().where('id', room.type).first()
        room.airvolume.airvolume = roomtypeat.airvolume_exhaust_operating;
        this.unit.airvolume.totalNeedAir +=
          roomtypeat.airvolume_exhaust_operating;
        this.unit.airvolume.totalDurationAir +=
          roomtypeat.airvolume_exhaust_basic;
      }.bind(this)
    );
  },

  calculateAirvolumeVariations() {
    this.unit.airvolume.nl = Math.round(this.unit.airvolume.nl);
    this.unit.airvolume.rl = Math.round(this.unit.airvolume.nl * this.fLstrl);
    this.unit.airvolume.il = Math.round(this.unit.airvolume.nl * this.fLstil);
    //this.unit.airvolume.fl = Math.round(this.unit.airvolume.nl * this.fLstfl)

    this.unit.airvolume.nlExchange = +parseFloat(
      this.unit.airvolume.nl / this.unit.airvolume.volume
    ).toFixed(2);
    this.unit.airvolume.rlExchange = +parseFloat(
      this.unit.airvolume.rl / this.unit.airvolume.volume
    ).toFixed(2);
    this.unit.airvolume.ilExchange = +parseFloat(
      this.unit.airvolume.il / this.unit.airvolume.volume
    ).toFixed(2);
    this.unit.airvolume.flExchange = +parseFloat(
      this.unit.airvolume.fl / this.unit.airvolume.volume
    ).toFixed(2);
  },
  calculateUld() {
    var f_uld = 3.1;
    var p_uld = 1.5;
    if (this.unit.overflowSeal == 1) var k_dichtung = 25;
    if (this.unit.overflowSeal == 0) var k_dichtung = 0;

    this.unit.rooms.forEach((room) => {
      var airvolume = 0;
      if (room.airvolume.operationmodeAirvolume > 0)
        airvolume = RoomtypesHasOperationmodesHasAirvolume.find(
          room.airvolume.operationmodeAirvolume
        ).duration_airvolume;
      if (airvolume <= 0 || airvolume == null)
        airvolume = room.airvolume.airvolume;
      if (airvolume <= 0 || airvolume == null) {
        room.airvolume.uld = 0;
        return;
      }
      room.airvolume.uld = +parseFloat(
        (f_uld * airvolume) / Math.pow(p_uld, 0.5) - k_dichtung
      ).toFixed(0);
    });
  },

  calculateValves() {
    this.unit.rooms.some(
      function (room) {
        if (room.valve.valvesAmmount == null || room.valve.valvesAmmount <= 0) {
          room.valve.valvesAmmount = Math.ceil(room.airvolume.airvolume / 60);
          if (this.unit.systemselection.pipeProfile == 2) {
            room.valve.pipesAmmount = Math.ceil(room.airvolume.airvolume / 20);
          } else {
            room.valve.pipesAmmount = Math.ceil(room.airvolume.airvolume / 30);
          }
          if (room.valve.pipesAmmount < room.valve.valvesAmmount) {
            room.valve.pipesAmmount = room.valve.valvesAmmount;
          }
        }
      }.bind(this)
    );
  },

  calculateTotalAirvolumes() {
    this.unit.airvolume.totalSupplyAir = 0;
    this.unit.airvolume.totalExhaustAir = 0;

    this.unit.rooms.forEach(
      function (room) {
        if (room.ventilationMeasure == 7) {
          room.airvolume.airvolume = 0;
          return;
        }
        if (room.airType == 2) {
          this.unit.airvolume.totalSupplyAir += parseFloat(
            room.airvolume.airvolume
          );
          room.airvolume.nlZu = +parseFloat(room.airvolume.airvolume).toFixed(
            0
          );
          room.airvolume.nlAb = "-";
        } else if (room.airType == 1) {
          this.unit.airvolume.totalExhaustAir += parseFloat(
            room.airvolume.airvolume
          );
          room.airvolume.nlAb = +parseFloat(room.airvolume.airvolume).toFixed(
            0
          );
          room.airvolume.nlZu = "-";
        }
        room.airvolume.rl = room.airvolume.airvolume * this.fLstrl;
        room.airvolume.il = room.airvolume.airvolume * this.fLstil;
        room.airvolume.fl = room.airvolume.airvolume * this.fLstfl;
      }.bind(this)
    );
    this.unit.airvolume.totalSupplyAir = Math.round(
      this.unit.airvolume.totalSupplyAir
    );
    this.unit.airvolume.totalExhaustAir = Math.round(
      this.unit.airvolume.totalExhaustAir
    );
  },
};
